import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { genericCustomStoreService } from 'src/app/shared/services/genericCustomStore.service';
import { EmployeeService } from 'src/app/shared/services/hr/employee.service';
import { NotifyService } from 'src/app/shared/services/hr/notify.service';

@Component({
  selector: 'app-employee-mission',
  templateUrl: './employee-mission.component.html',
  styleUrls: ['./employee-mission.component.scss']
})
export class EmployeeMissionComponent implements OnInit {

  missions: any[] = [];
  loading = false;

  // Popup تفاصيل مالية
  financialPopupVisible = false;
  selectedMission: any = null;
  missionTypes : any[] = [];
  constructor(
    private _EmployeeService: EmployeeService,
    private gt: genericCustomStoreService,
    public router: Router,
    public translate: TranslateService,
    private notifyService: NotifyService
  ) {}

  ngOnInit(): void {
    this.loadMissions();
  }

  loadMissions() {
        this._EmployeeService.GetEmployeeMissionTypes().subscribe((res: any[]) => {
      this.missionTypes = res;
    });
    debugger
    this.loading = true;
    this._EmployeeService.GetAllEmployeeMission().subscribe({
      next: (res: any) => {
        this.missions = res;
        this.loading = false;
      },
      error: () => {
        this.notifyService.notifyfunerr('حدث خطأ أثناء تحميل البيانات');
        this.loading = false;
      }
    });
  }

  goToAdd() {
    this.router.navigate(['/hr/add-edit-EmployeeMission']);
  }

  goToEdit(id: number) {
    this.router.navigate(['/hr/add-edit-EmployeeMission'], { queryParams: { id } });
  }

  showFinancialDetails(mission: any) {
    this.selectedMission = mission;
    this.financialPopupVisible = true;
  }

  deleteMission(id: number) {
    this._EmployeeService.DeleteEmployeeMission(id).subscribe({
      next: () => {
        this.notifyService.notifyfun('تم حذف المأمورية بنجاح');
        this.loadMissions();
      },
      error: () => {
        this.notifyService.notifyfunerr('حدث خطأ أثناء الحذف');
      }
    });
  }

  getMissionStatusText(status: number): string {
    const map: any = { 0: 'معلقة', 1: 'موافق عليها', 2: 'مرفوضة', 3: 'مكتملة' };
    return map[status] ?? 'غير معروف';
  }

  getMissionStatusColor(status: number): string {
    const map: any = { 0: 'warning', 1: 'success', 2: 'danger', 3: 'default' };
    return map[status] ?? 'default';
  }

  getMissionTypeText(type: number): string {
    const map: any = { 0: 'داخلية', 1: 'خارجية' };
    return map[type] ?? '';
  }
}